import { render, staticRenderFns } from "./GenerationContentCategories.vue?vue&type=template&id=2906d578&"
import script from "./GenerationContentCategories.vue?vue&type=script&lang=js&"
export * from "./GenerationContentCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports